import i18n from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import _en from '../locales/en.json';
import _it from '../locales/it.json';
import _es from '../locales/es.json';

// Kwick's
import kwick_en from '../locales/kwick/en.json';
import kwick_it from '../locales/kwick/it.json';
import plenitude_en from '../locales/plenitude/en.json';
import plenitude_it from '../locales/plenitude/it.json';
import solectivo_en from '../locales/solectivo/en.json';
import solectivo_es from '../locales/solectivo/es.json';
import eon_it from '../locales/eon/it.json';
import eon_en from '../locales/eon/en.json';

import merge from 'lodash/merge';

const ENV = (import.meta as any).env;

const resources: Record<string, any> = {
  _en: { common: _en },
  _it: { common: _it },
  _es: { common: _es },
  kwick_en: { common: merge({}, _en, kwick_en) },
  kwick_it: { common: merge({}, _it, kwick_it) },
  plenitude_en: { common: merge({}, _en, plenitude_en) },
  plenitude_it: { common: merge({}, _it, plenitude_it) },
  solectivo_en: { common: merge({}, _en, solectivo_en) },
  solectivo_es: { common: merge({}, _es, solectivo_es) },
  eon_en: { common: merge({}, _en, eon_en) },
  eon_it: { common: merge({}, _it, eon_it) },
  admin_en: { common: merge({}, _en) },
  admin_it: { common: merge({}, _it) },
  admin_es: { common: merge({}, _es) },
};



i18n
  .use(initReactI18next)
  .init({
  compatibilityJSON: 'v3',
  ns: ['common'],
  defaultNS: 'common',
  resources,
  // debug: true,
  lng: `${ENV.VITE_APP_ORG}_${ENV.VITE_APP_LANGUAGE}`,
  fallbackLng: `${ENV.VITE_APP_ORG}_en`,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense:false,
 }
});


export const TranslationsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
